import { useQuery } from '@apollo/client';
import { GET_ENABLED_CUSTOM_FIELDS_QUERY } from './getEnabledCustomFieldsQuery';

export const useGetEnabledCustomFieldsQuery = options =>
  useQuery(GET_ENABLED_CUSTOM_FIELDS_QUERY, options);
